<p-dialog
  header="Sitzungsdetails"
  [modal]="true"
  [draggable]="false"
  position="top"
  [(visible)]="this.sessionDetailsService.isDetailsVisible"
  [style]="{ width: '75rem' }"
  [footerTemplate]="footer"
>
  <p-tabs value="0">
    <p-tablist>
      <p-tab value="0">Allgemein</p-tab>
      <p-tab value="1">Chatverlauf</p-tab>
      <p-tab value="2">Auditlog</p-tab>
      <p-tab value="3">Learning Guidance Debug</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <div class="mt-3">

          <div class="flex flex-row justify-between items-center mt-3">
            <div>
              <span class="inline-block me-2 text-base w-[150px]">Verbindungsdauer:</span>
              <span class="text-base">
                {{this.sessionDetailsService.connectedDuration}}
              </span>
            </div>
          </div>
          <div class="flex flex-row justify-between items-center mt-3">
            <div>
              <span class="inline-block me-2 text-base w-[150px]">Erstellt am:</span>
              <span class="text-base">
                {{this.statusService.selectedStatus.created | date: "dd.MM.yyyy&nbsp;HH:mm:ss"}}
              </span>
            </div>
          </div>
          <div class="flex flex-row justify-between items-center mt-3">
            <div>
              <span class="inline-block me-2 text-base w-[150px]">Zuletzt geändert:</span>
              @if (this.statusService.selectedStatus.updated.startsWith("1970")) {
              <span class="text-base"> Keine Änderung</span>
              }
              @else {
              <span class="text-base">
                {{ this.statusService.selectedStatus.updated | date: "dd.MM.yyyy&nbsp;HH:mm:ss"}}
              </span>
              }
            </div>
          </div>
          <div class="flex flex-row justify-between items-center mt-3">
            <div>
              <span class="inline-block me-2 text-base w-[150px]">Gestartet am:</span>
              <span class="text-base">
                {{this.statusService.selectedStatus.startDate | date: "dd.MM.yyyy&nbsp;HH:mm:ss"}}
              </span>
            </div>
          </div>
          <div class="flex flex-row justify-between items-center mt-3">
            <div>
              <span class="inline-block me-2 text-base w-[150px]">Prüfungsende:</span>
              <span class="text-base">
                {{this.statusService.selectedStatus.endDate | date: "dd.MM.yyyy&nbsp;HH:mm:ss"}}
              </span>
            </div>
          </div>
          <div class="flex flex-row items-center mt-3">
            <div>
              <span class="inline-block me-2 text-base w-[150px]">Korrigiert am:</span>
              @if (this.statusService.selectedStatus.korrektorFinishedDate.startsWith("1970")) {
              <span class="text-base"> Keine Korrektur</span>
              }
              @else {
              <span class="text-base">
                {{this.statusService.selectedStatus.korrektorFinishedDate | date: "dd.MM.yyyy&nbsp;HH:mm:ss"}}
              </span>
              }
            </div>
          </div>
        </div>
        <div class="flex flex-row justify-between items-center mt-3">
          <div>
            <span class="inline-block me-2 text-base w-[150px]">Nachrichten im Chatverlauf:</span>
            <span class="text-base">
              {{this.statusService.selectedStatus.chatHistoryItems.length}}
            </span>
          </div>
        </div>
      </p-tabpanel>
      <p-tabpanel value="1">
        <div class="h-[400px] overflow-y-auto mt-3">
          @for (msg of this.statusService.selectedStatus.chatHistoryItems; track $index; let isFirst = $first) {
          @if(msg.bypass !== true && !this.sessionDetailsService.isButtonsCard(msg)) {
          <div
            class="flex flex-row justify-end"
            [ngClass]="{ 'justify-end': msg.role === 'user', 'justify-start': msg.role !== 'user', 'mt-5': !isFirst }"
          >
            <div
              class="border border-gray-200 rounded-lg shadow-lg p-2"
              style="max-width: 70%"
              [ngClass]="{ 'text-end bg-[#00B0D0] text-white': msg.role === 'user', 'text-start': msg.role !== 'user'}"
            >
              @if (this.sessionDetailsService.isHtmlCard(msg)) {
              <div [innerHTML]="this.sessionDetailsService.getHtmlCard(msg)"></div>
              } @else {
              <span>
                {{msg.content }}
              </span>
              }
            </div>
          </div>
          }
          }
        </div>
      </p-tabpanel>
      <p-tabpanel value="2">
        <p class="m-0">
          <p-table
            [value]="this.sessionDetailsService.auditLogs"
            [tableStyle]="{ 'min-width': '30rem' }"
          >
            <ng-template #header>
              <tr>
                <th>Uhrzeit</th>
                <th>Msg</th>
              </tr>
            </ng-template>
            <ng-template
              #body
              let-log
            >
              <tr>
                <td>{{ log.created | date: "dd.MM.yyyy&nbsp;HH:mm:ss" }}</td>
                <td>{{ this.sessionDetailsService.getMessageForLogEntry(log) }}</td>
              </tr>
            </ng-template>
          </p-table>
        </p>
      </p-tabpanel>
      <p-tabpanel value="3">
        @if (this.debugTrace; as trace) {
        <div class="h-[500px] overflow-y-auto mt-3 space-y-4">
          <div>
            <span class="font-semibold text-base">Generiert am:</span>
            <span class="text-base ms-2">{{ trace.generatedAt | date: "dd.MM.yyyy HH:mm:ss" }}</span>
          </div>
          <div>
            <span class="font-semibold text-base">KI Score:</span>
            <span class="text-base ms-2">{{ trace.kiScore ?? 'nicht verfügbar' }}</span>
          </div>

          <div>
            <span class="font-semibold text-base block mb-1">Input Feedback Text:</span>
            <pre
              class="bg-gray-100 p-3 rounded text-sm whitespace-pre-wrap max-h-[200px] overflow-y-auto">{{ trace.inputFeedbackText }}</pre>
          </div>

          <div>
            <span class="font-semibold text-base block mb-1">Weak Points Prompt:</span>
            <pre
              class="bg-blue-50 p-3 rounded text-sm whitespace-pre-wrap max-h-[200px] overflow-y-auto">{{ trace.weakPointsPrompt }}</pre>
          </div>
          <div>
            <span class="font-semibold text-base block mb-1">Weak Points Response:</span>
            <pre
              class="bg-green-50 p-3 rounded text-sm whitespace-pre-wrap max-h-[200px] overflow-y-auto">{{ trace.weakPointsResponse }}</pre>
          </div>

          @if (trace.weakPoints.length > 0) {
          <div>
            <span class="font-semibold text-base block mb-1">Erkannte Schwachpunkte:</span>
            <ul class="list-disc list-inside">
              @for (wp of trace.weakPoints; track $index) {
              <li>Aufgabe {{ wp.aufgabenNummer }}: {{ wp.description }} <span class="text-gray-500">(Relevanz: {{
                  wp.relevanceScore }})</span></li>
              }
            </ul>
          </div>
          }

          @if (trace.chunksFound.length > 0) {
          <div>
            <span class="font-semibold text-base block mb-1">Gefundene PDF-Chunks ({{ trace.chunksFound.length
              }}):</span>
            @for (chunk of trace.chunksFound; track $index) {
            <div class="bg-gray-50 p-2 rounded mb-2 text-sm">
              <div class="text-gray-500 text-xs mb-1">
                Chunk: {{ chunk.chunkId }} | Chapter: {{ chunk.chapterId }}
                @if (chunk.similarity != null) {
                | <span
                  class="font-semibold"
                  [ngClass]="{'text-green-600': chunk.similarity >= 0.8, 'text-yellow-600': chunk.similarity >= 0.5 && chunk.similarity < 0.8, 'text-red-600': chunk.similarity < 0.5}"
                >Similarity: {{ (chunk.similarity * 100).toFixed(1) }}%</span>
                }
              </div>
              <div class="whitespace-pre-wrap max-h-[100px] overflow-y-auto">{{ chunk.content }}</div>
            </div>
            }
          </div>
          }

          <div>
            <span class="font-semibold text-base block mb-1">Explanation Prompt:</span>
            <textarea
              [(ngModel)]="editableExplanationPrompt"
              class="w-full p-3 rounded border border-gray-300 text-sm font-mono"
              rows="8"
              placeholder="Bearbeitbarer Prompt"
            ></textarea>
            <div class="mt-2 flex gap-2">
              <p-button
                label="Regenerate"
                severity="success"
                icon="pi pi-refresh"
                (onClick)="regenerateExplanation()"
                [loading]="isRegenerating"
              />
            </div>
          </div>

          @if (hasRegeneratedExplanation) {
          <div class="grid grid-cols-2 gap-4">
            <div>
              <span class="font-semibold text-base block mb-1">Original Response:</span>
              <div
                class="bg-green-50 p-3 rounded text-sm whitespace-pre-wrap max-h-[200px] overflow-y-auto"
                [innerHTML]="trace.explanationResponse"
              ></div>
            </div>
            <div>
              <span class="font-semibold text-base block mb-1">Regenerated Response:</span>
              <div
                class="bg-orange-50 p-3 rounded text-sm whitespace-pre-wrap max-h-[200px] overflow-y-auto border-2 border-orange-400"
                [innerHTML]="regeneratedExplanation"
              ></div>
            </div>
          </div>
          } @else {
          <div>
            <span class="font-semibold text-base block mb-1">Original Response:</span>
            <div
              class="bg-green-50 p-3 rounded text-sm whitespace-pre-wrap max-h-[200px] overflow-y-auto"
              [innerHTML]="trace.explanationResponse"
            ></div>
          </div>
          }
        </div>
        } @else {
        <div class="mt-3 text-gray-500">Keine Learning Guidance Debug-Daten vorhanden.</div>
        }
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</p-dialog>

<ng-template #footer>
  <p-button
    label="Schließen"
    severity="secondary"
    (onClick)="this.sessionDetailsService.isDetailsVisible = false"
  />
</ng-template>